/*global google*/
import React, {
  useState,
  useMemo,
  useContext,
  useCallback,
  useEffect,
} from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Polyline,
  StreetViewPanorama,
} from "react-google-maps";
import { useSelector, useDispatch } from "react-redux";
import { notification, Modal, Button, List } from "antd";
import {
  DragOutlined,
  ExclamationCircleOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import Draggable from "react-draggable";
import Api from "../../../../services/ServiceApi";
import { googleKey } from "../../../../config";
import * as icons from "../../../../assets/icons";
import * as markersIcon from "../../../../assets/markersIcon";
import { RepairTypeButton } from "../../../../components";
import RepairSiteDetail from "./RepairSiteDetail";
import RepairSJDetail from "./RepairSJDetail";
import RepairLoopDetail from "./RepairLoopDetail";
import RepairCoreDetail from "./RepairCoreDetail";
import { authUserContext } from "../../../../contexts/authContext";
import { MaxiColors } from "../../../../theme";
import {
  getRepairPoint,
  setRepairList,
  setRepairDetail,
  setCenterMap,
  setCoverageFibers,
} from "../../../../actions/boldgroup/repairPointAction";
import RepairTypeStraddle from "./RepairTypeStraddle";
import RepairTypeLoop from "./RepairTypeLoop";
import RepairTypeCore from "./RepairTypeCore";
import RepairTypeIndoor from "./RepairTypeIndoor";
// import { DirectionsService } from '@react-google-maps/api';

const { confirm } = Modal;

const initRepairType = {
  straddle: {
    markers: [
      {
        pkId: null,
        latitude: 0,
        longitude: 0,
        siteCode: "",
        siteName: "",
        distanceRepairPoint: 0,
        remark: "",
        files: [],
        stationCode: 1,
        description: "Site Origin",
        layerCode: "SITE",
        icon: markersIcon.siteNormal,
      },
      {
        pkId: null,
        latitude: 0,
        longitude: 0,
        siteCode: "",
        siteName: "",
        distanceRepairPoint: 0,
        remark: "",
        files: [],
        stationCode: 2,
        description: "Site Destination",
        layerCode: "SITE",
        icon: markersIcon.siteNormal,
      },
      {
        latitude: 0,
        longitude: 0,
        enclosure: "",
        distanceLoop: 0,
        siteOTDR: "",
        distanceOTDR: 0,
        remark: "",
        files: [],
        stationCode: 1,
        description: "Closure Origin",
        layerCode: "SJ",
        icon: markersIcon.sjNormal,
      },
      {
        latitude: 0,
        longitude: 0,
        enclosure: "",
        distanceLoop: 0,
        siteOTDR: "",
        distanceOTDR: 0,
        remark: "",
        files: [],
        stationCode: 2,
        description: "Closure Destination",
        layerCode: "SJ",
        icon: markersIcon.sjNormal,
      },
    ],
    polylines: [],
    name: "ลากคร่อม",
    repairTypeID: 2,
    repairTypeName: "STRADDLE",
  },
  loop: {
    markers: [
      {
        latitude: 0,
        longitude: 0,
        siteName: "",
        distanceRepairPoint: 0,
        remark: "",
        files: [],
        stationCode: 1,
        description: "Site Origin",
        layerCode: "SITE",
        icon: markersIcon.siteNormal,
      },
      {
        latitude: 0,
        longitude: 0,
        siteName: "",
        distanceRepairPoint: 0,
        remark: "",
        files: [],
        stationCode: 2,
        description: "Site Destination",
        layerCode: "SITE",
        icon: markersIcon.siteNormal,
      },
      {
        latitude: 0,
        longitude: 0,
        loopID: "",
        enclosure: "",
        distanceLoop: 0,
        remark: "",
        files: [],
        stationCode: 3,
        description: "Loop",
        layerCode: "LOOP",
        detail: "",
        icon: markersIcon.loopNormal,
      },
      {
        latitude: 0,
        longitude: 0,
        enclosure: "",
        distanceLoop: 0,
        siteOTDR: "",
        distanceOTDR: 0,
        remark: "",
        files: [],
        stationCode: 3,
        description: "Closure",
        layerCode: "SJ",
        icon: markersIcon.sjNormal,
      },
    ],
    polylines: [],
    name: "ปลด Loop +Splice",
    repairTypeID: 2,
    repairTypeName: "LOOP",
  },
  core: {
    markers: [
      {
        latitude: 0,
        longitude: 0,
        siteName: "",
        distanceRepairPoint: 0,
        remark: "",
        files: [],
        stationCode: 1,
        description: "Site Origin",
        layerCode: "SITE",
        icon: markersIcon.siteNormal,
      },
      {
        latitude: 0,
        longitude: 0,
        siteName: "",
        distanceRepairPoint: 0,
        remark: "",
        files: [],
        stationCode: 2,
        description: "Site Destination",
        layerCode: "SITE",
        icon: markersIcon.siteNormal,
      },
      {
        latitude: 0.0,
        longitude: 0.0,
        siteName: "",
        distanceRepairPoint: 0,
        beforeCore: 0,
        afterCore: 0,
        remark: "",
        files: [],
        stationCode: 3,
        description: "ODF/MDF",
        layerCode: "CORE",
        // direction: "from",
        icon: markersIcon.coreNormal,
      },
    ],
    polylines: [],
    name: "โยก Core",
    repairTypeID: 3,
    repairTypeName: "CORE",
  },
  indoor: {
    markers: [
      {
        latitude: 0,
        longitude: 0,
        siteName: "",
        distanceRepairPoint: 0,
        remark: "",
        files: [],
        stationCode: 1,
        description: "Site Origin",
        layerCode: "SITE",
        icon: markersIcon.siteNormal,
      },
      {
        latitude: 0,
        longitude: 0,
        siteName: "",
        distanceRepairPoint: 0,
        remark: "",
        files: [],
        stationCode: 2,
        description: "Site Destination",
        layerCode: "SITE",
        icon: markersIcon.siteNormal,
      },
    ],
    polylines: [],
    name: "Indoor Other",
    repairTypeID: 4,
    repairTypeName: "INDOOR",
  },
};

const initMapOptions = {
  // mapTypeControl: true,
  streetViewControl: true,
  // styles: styleMap,
  draggableCursor: "default",

  // mapTypeId: "roadmap",
};

const initPosition = {
  x: 0, //-440,
  y: 0,
  visible: false,
  layerDetail: {},
  isEdit: false,
};
const initPositionRoutes = {
  x: 440,
  y: 0,
  visible: false,
  layerDetail: {},
  isEdit: false,
};

const GoogleMapCustomized = withScriptjs(
  withGoogleMap((props) => {
    const {
      markers,
      addMarkers,
      polylines,
      addPolylines,
      mapOptions,
      onClick,
      sampleFiber
    } = props;

    // const [markerList, setMarkerList] = useState(markers);

    // useMemo(() => {
    //   setMarkerList(markers);
    // }, [markers]);

    // console.log("props.google", google.maps.MapTypeId);
    return (
      <GoogleMap
        defaultZoom={props.zoom}
        defaultCenter={props.center}
        center={props.center}
        options={{
          ...mapOptions,
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.TOP_LEFT,
            mapTypeIds: [
              google.maps.MapTypeId.ROADMAP,
              google.maps.MapTypeId.SATELLITE,
              google.maps.MapTypeId.HYBRID,
              google.maps.MapTypeId.TERRAIN,
            ],
            // mapTypeIds: ["Custom1", "satellite"],
          },
        }}
        // cursor={cursor}
        onClick={onClick}
      >
        <StreetViewPanorama
          onVisibleChanged={(e) => console.log("onVisibleChanged", e)}
          getVisible={(e) => console.log("getVisible", e)}
        />
        {markers.map((marker, index) => (
          <Marker
            key={`repair_marker_${index}`}
            position={{ lat: marker.latitude, lng: marker.longitude }}
            icon={marker.icon}
            onClick={() =>  props.onMarkerClick(marker, index)}
            animation={marker.animation}
            visible={marker.visible}
            // visible={marker.visible}
            // onClick={props.onMarkerClick(marker)}
          />
        ))}
        {addMarkers.map((marker, index) => (
          <Marker
            key={`add_repair_marker_${index}`}
            position={{
              lat: +marker.latitude || 0,
              lng: +marker.longitude || 0,
            }}
            icon={marker.icon}
            // onClick={() => props.onMarkerClick(marker)}
          />
        ))}
        {polylines.map((polyline, index) => (
          <Polyline
            key={`polyline_${index}`}
            path={polyline.coordinate}
            geodesic={true}
            options={{
              strokeColor: "#ff2527",
              strokeOpacity: 0.75,
              strokeWeight: 2,
            }}
            visible={polyline.visible}
          />
        ))}
        {addPolylines.map((polyline, index) => (
          <Polyline
            key={`add_polyline_${index}`}
            path={polyline.coordinate}
            geodesic={true}
            options={{
              strokeColor: "#ff2527",
              strokeOpacity: 0.75,
              strokeWeight: 2,
            }}
          />
        ))}
        {sampleFiber.map((sample, index) => (
          <Polyline
            key={`sample_polyline_${index}`}
            path={sample.coordinate}
            geodesic={true}
            options={{
              strokeColor: sample.active ? "#ff2527" : "#0500a3",
              strokeOpacity: sample.active ? 1 : 0.75,
              strokeWeight: sample.active ? 3 : 2,
            }}
          />
        ))}
      </GoogleMap>
    );
  })
);

const MapRepairPoint = ({ jobData , actionSatus , refJobID}) => {
  // const { job_id: jobID } = jobData;
  const repairType = new Map([
    [
      1,
      {
        id: 1,
        name: "ลากคร่อม",
        icon: icons.straddle,
        iconDis: icons.straddleDis,
      },
    ],
    [
      2,
      {
        id: 2,
        name: "ปลด Loop +Splice",
        icon: icons.loop,
        iconDis: icons.loopDis,
      },
    ],
    [3, { id: 3, name: "โยก Core", icon: icons.core, iconDis: icons.coreDis }],
    [
      4,
      {
        id: 4,
        name: "อื่นๆ Indoor",
        icon: icons.indoorOther,
        iconDis: icons.indoorOtherDis,
      },
    ],
  ]);
  const { repairList, repairDetail, mapCenter, coverageRoutes } = useSelector(
    (state) => ({
      repairList: state.repairPoint.repairList,
      repairDetail: state.repairPoint?.repairDetail,
      mapCenter: state.repairPoint?.mapCenter,
      coverageRoutes: state.repairPoint?.coverageRoutes,
    })
  );
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  // const [repairData, setRepairData] = useState([]);
  // const [defaultLatLng, setDefaultLatLng] = useState({
  //   lat: 13.736717,
  //   lng: 100.523186,
  // });

  const [markers, setMarkers] = useState([]);
  const [polylines, setPolylines] = useState([]);
  const [positionDetail, setPositionDetail] = useState(initPosition);
  const [positionAdd, setPositionAdd] = useState(initPosition);
  const [modalAddVisible, setModalAddVisible] = useState(false);
  const [mapOptions, setMapOptions] = useState(initMapOptions);
  const authUserValue = useContext(authUserContext);
  const [positionRoutes, setPositionRoutes] = useState(initPositionRoutes);

  // const [sampleFiber, setSampleFiber] = useState([]);

  const handleConfirmRepairTypeRemove = (repairPoint) => {
    confirm({
      title: "Do you Want to delete item ?",
      icon: <ExclamationCircleOutlined />,
      content: `ต้องการลบประเภทการซ่อม ${
        repairType.get(repairPoint.repairTypeID).name
      }`,
      onOk() {
        return Api.post("repairpoint/deleterepairpoint", {
          repairPointID: repairPoint.repairPointID,
          jobID: repairPoint.jobID,
          userName: authUserValue.username,
        })
          .then(({ data }) => {
            if (data.result.code === "P" || data.result.value === "P") {
              notification.success({
                message: "Success",
                description: "ลบรายการประเภทการซ่อมสำเร็จ",
              });
              dispatch(
                setRepairList(
                  repairList.filter(
                    (f) => f.repairPointID !== repairPoint.repairPointID
                  )
                )
              );
              // setRepairData(
              //   repairList.filter(
              //     (f) => f.repairPointID !== repairPoint.repairPointID
              //   )
              // );
              setMarkers(
                markers.filter(
                  (f) => f.repairPointID !== repairPoint.repairPointID
                )
              );
              setPolylines(
                polylines.filter(
                  (f) => f.repairPointID !== repairPoint.repairPointID
                )
              );
            } else {
              notification.error({
                message: "เกิดข้อผิดพลาด",
                description: data.result.showText,
              });
            }
          })
          .catch((e) => {
            notification.error({
              message: "เกิดข้อผิดพลาด",
              description: `ไม่สามารถลบ ประเภทการซ่อม ${
                repairType.get(repairPoint.repairTypeID).name
              } ได้`,
            });
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleGetRepairPoint = useCallback(async () => {
    try {
      var setData =   jobData["ref_job_id"] !== null &&  jobData["ref_job_id"] !== undefined ?  {job_id: jobData["ref_job_id"] } : jobData ;
      await dispatch(
        getRepairPoint({  ...setData  , userName: authUserValue.username })
      );
    } catch (err) {
      // setError(err.message);
    }
  }, [authUserValue.username, dispatch, jobData]);

  useEffect(() => {
    if(actionSatus && jobData["ref_job_id"] !== undefined && jobData["ref_job_id"] !== null){
    handleGetRepairPoint()
      .then(() => {
        setIsLoading(false);
      })
      .catch();
    }
  }, [jobData["ref_job_id"] !== undefined && jobData["ref_job_id"] !== null ? handleGetRepairPoint : []] );
  useMemo(() => {
    handleGetRepairPoint()
      .then(() => {
        setIsLoading(false);
      })
      .catch();
  }, [handleGetRepairPoint]);

  const handleGetLatLng = (latitude, longitude) => {
    if (positionAdd.visible) {
      dispatch(
        setRepairDetail({
          ...repairDetail,
          markers: repairDetail.markers.map((m) => {
            if (m.active) {
              return { ...m, latitude: latitude, longitude: longitude };
            }
            return m;
          }),
        })
      );
    }

    if (positionDetail.visible && positionDetail.isEdit) {
      dispatch(
        setRepairDetail({
          ...repairDetail,
          markers: repairDetail.markers.map((m) => {
            if (m.active) {
              return { ...m, latitude: latitude, longitude: longitude };
            }
            return m;
          }),
        })
      );
    }
  };

  useEffect(() => {
    const reduceMarkers = repairList
      // .filter((f) => f.active)
      .reduce((total, value) => {
        value.markers.forEach((marker) => {
          let icon = null;
          switch (marker.layerCode) {
            case "SITE":
              icon = markersIcon.siteNormal;
              break;
            case "SJ":
              icon = markersIcon.sjNormal;
              break;
            case "LOOP":
              icon = markersIcon.loopNormal;
              break;
            case "CORE":
              icon = markersIcon.coreNormal;
              break;
            default:
              break;
          }
          marker.icon = icon;
          marker.visible = value.active ? true : false;
        });

        return [...total, ...value.markers];
      }, []);
    const reducePolylines = repairList
      // .filter((f) => f.active)
      .reduce((total, value) => {
        value.polylines.forEach((polyline) => {
          polyline.coordinate = polyline.coordinate.map((m) => ({
            ...m,
            lat: m.latitude,
            lng: m.longitude,
          }));
          polyline.visible = value.active ? true : false;
        });
        return [...total, ...value.polylines];
      }, []);
    setMarkers(reduceMarkers);
    setPolylines(reducePolylines);

    // setTypeActive(repairList.map((m) => m.repairPointID));
    if (repairList.length) {
      dispatch(
        setCenterMap({
          lat: repairList[0]?.markers[0].latitude,
          lng: repairList[0]?.markers[0].longitude,
        })
      );
      // setDefaultLatLng({
      //   lat: repairList[0]?.markers[0].latitude,
      //   lng: repairList[0]?.markers[0].longitude,
      // });
    }

    return () => {};
  }, [dispatch, repairList]);
;

  // useEffect(() => {
  //   const aaa = markers.map((m) => {
  //     if (!typeActive.includes(m.repairPointID)) {
  //       return { ...m, visible: false };
  //     }
  //     return { ...m, visible: true };
  //   });
  //   console.log("aaa", aaa);
  //   setMarkers(aaa);
  //   return () => {};
  // }, [typeActive]);

  return (
    <>
      {!isLoading && (
        <>
        {/* {actionSatus ? null : */}
          <Draggable cancel=".ant-btn, .form-control, .btn">
            <div className="draggable-repair-body">
              <div className="draggable-repair-head">
                <div style={{ display: "flex", flex: 1 }}>ประเภทการซ่อม</div>
                <div style={{ display: "flex" }}>
                  <DragOutlined />
                </div>
              </div>
              <div className="row">
                {repairList.map((item, index) => (
                  <div className="col-12" key={index}>
                    <RepairTypeButton
                      active={item.active}
                      left={
                        !item.active ? (
                          <img
                            src={repairType.get(item.repairTypeID).iconDis}
                            alt=""
                          />
                        ) : (
                          <img
                            src={repairType.get(item.repairTypeID).icon}
                            alt=""
                          />
                        )
                      }
                      title={repairType.get(item.repairTypeID).name}
                      onClick={() => {
                        const newRepairData = repairList.map((m, i) => {
                          if (i === index) {
                            return { ...m, active: !m.active };
                          }
                          return m;
                        });
                        dispatch(setRepairList(newRepairData));
                        // setRepairData(newRepairData);
                        // setTypeActive(
                        //   newRepairData
                        //     .filter((f) => f.active)
                        //     .map((m) => m.repairPointID)
                        // );
                      }}
                      onRemove={() => {
                        handleConfirmRepairTypeRemove(item);
                      }}
                    />
                  </div>
                ))}
              </div>

              <div className="row justify-content-center mt-5">
                <div className="col-12">
                  <Button
                    style={{
                      backgroundColor: MaxiColors.PRIMARY,
                      width: "100%",
                    }}
                    onClick={() => setModalAddVisible(true)}
                    disabled={actionSatus}
                  >
                    <span
                      className="default-thai-font"
                      style={{ color: "#fff" }}
                    >
                      เพิ่มรายละเอียดการซ่อมบำรุง
                    </span>
                  </Button>
                </div>
              </div>
            </div>
          </Draggable>
{/* } */}
          {positionDetail.visible && (
            <Draggable
              cancel=".ant-btn, .form-control, .btn"
              // defaultPosition={{ x: -200, y: 0 }}
              position={positionDetail}
              // onStart={(e, data) => {
              //   console.log("Event: ", e);
              //   console.log("Data: ", data);
              // }}
              onStop={(e, data) => {
                // console.log("Event: ", e);
                // console.log("Data: ", data);
                setPositionDetail({ ...positionDetail, x: data.x, y: data.y });
              }}
              // onDrag={this.handleDrag}
            >
              <div
                className="draggable-repair-body"
                style={{ width: Math.abs(initPosition.x) - 20 }}
              >
                {positionDetail.layerDetail.layerCode === "SITE" && (
                  <RepairSiteDetail
                    layerDetail={positionDetail.layerDetail}
                    onClose={() => {
                      setPositionDetail(initPosition);
                      setMapOptions({
                        ...mapOptions,
                        draggableCursor: "default",
                      });
                    }}
                    onEdit={(value) => {
                      setMapOptions({
                        ...mapOptions,
                        draggableCursor: value ? "crosshair" : "default",
                      });
                      setPositionDetail({
                        ...positionDetail,
                        isEdit: value,
                      });
                    }}
                    statusAction={actionSatus}
                  />
                )}
                {positionDetail.layerDetail.layerCode === "SJ" && (
                  <RepairSJDetail
                    layerDetail={positionDetail.layerDetail}
                    onClose={() => {
                      setPositionDetail(initPosition);
                    }}
                    onEdit={(value) => {
                      setMapOptions({
                        ...mapOptions,
                        draggableCursor: value ? "crosshair" : "default",
                      });
                      setPositionDetail({
                        ...positionDetail,
                        isEdit: value,
                      });
                    }}
                  />
                )}
                {positionDetail.layerDetail.layerCode === "LOOP" && (
                  <RepairLoopDetail
                    layerDetail={positionDetail.layerDetail}
                    onClose={() => {
                      setPositionDetail(initPosition);
                    }}
                    onEdit={(value) => {
                      setMapOptions({
                        ...mapOptions,
                        draggableCursor: value ? "crosshair" : "default",
                      });
                      setPositionDetail({
                        ...positionDetail,
                        isEdit: value,
                      });
                    }}
                  />
                )}
                {positionDetail.layerDetail.layerCode === "CORE" && (
                  <RepairCoreDetail
                    layerDetail={positionDetail.layerDetail}
                    onClose={() => {
                      setPositionDetail(initPosition);
                    }}
                    onEdit={(value) => {
                      setMapOptions({
                        ...mapOptions,
                        draggableCursor: value ? "crosshair" : "default",
                      });
                      setPositionDetail({
                        ...positionDetail,
                        isEdit: value,
                      });
                    }}
                  />
                )}
              </div>
            </Draggable>
          )}
          {positionAdd.visible && (
            <Draggable
              cancel=".ant-btn, .form-control, .btn, .anticon-close"
              position={positionDetail}
              onStop={(e, data) => {
                setPositionDetail({ ...positionDetail, x: data.x, y: data.y });
              }}
            >
              <div
                className="draggable-repair-body"
                style={{ width: Math.abs(initPosition.x) - 20 }}
              >
                <div className="draggable-repair-head">
                  <div style={{ display: "flex", flex: 1 }}>
                    เพิ่ม ประเภท{repairType.get(repairDetail.repairTypeID).name}
                  </div>
                  <div style={{ display: "flex" }}>
                    <CloseOutlined
                      onClick={() => {
                        setPositionAdd({ ...positionAdd, visible: false });
                        setMapOptions({
                          ...mapOptions,
                          draggableCursor: "default",
                        });
                      }}
                      style={{ color: MaxiColors.DANGER }}
                    />
                  </div>
                </div>
                {repairDetail.repairTypeID === 1 && (
                  <RepairTypeStraddle
                    onSubmit={() => {
                      setPositionAdd({ ...positionAdd, visible: false });
                      setMapOptions({
                        ...mapOptions,
                        draggableCursor: "default",
                      });
                    }}
                  />
                )}
                {repairDetail.repairTypeID === 2 && (
                  <RepairTypeLoop
                    onSubmit={() => {
                      setPositionAdd({ ...positionAdd, visible: false });
                      setMapOptions({
                        ...mapOptions,
                        draggableCursor: "default",
                      });
                    }}
                  />
                )}
                {repairDetail.repairTypeID === 3 && (
                  <RepairTypeCore
                    onSubmit={() => {
                      setPositionAdd({ ...positionAdd, visible: false });
                      setMapOptions({
                        ...mapOptions,
                        draggableCursor: "default",
                      });
                    }}
                  />
                )}
                {repairDetail.repairTypeID === 4 && (
                  <RepairTypeIndoor
                    onSubmit={() => {
                      setPositionAdd({ ...positionAdd, visible: false });
                      setMapOptions({
                        ...mapOptions,
                        draggableCursor: "default",
                      });
                    }}
                  />
                )}
              </div>
            </Draggable>
          )}
          {!!coverageRoutes.length && (
            <Draggable
              cancel=".ant-btn, .form-control"
              position={positionRoutes}
              onStop={(e, data) => {
                setPositionRoutes({ ...positionRoutes, x: data.x, y: data.y });
              }}
            >
              <div
                className="draggable-repair-body"
                style={{
                  width: Math.abs(initPositionRoutes.x) - 20,
                }}
              >
                <div className="draggable-repair-head">
                  <div style={{ display: "flex", flex: 1 }}>
                    Fiber ที่อยู่ใกล้ Site ต้นทาง
                  </div>
                  <div style={{ display: "flex" }}>
                    <CloseOutlined
                      onClick={() => {
                        dispatch(setCoverageFibers([]));
                      }}
                      style={{ color: MaxiColors.DANGER }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    height: 500,
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <List
                    size="small"
                    itemLayout="horizontal"
                    dataSource={coverageRoutes}
                    renderItem={(fiber, index) => (
                      <div
                        className="row"
                        style={{ padding: "2px 15px", alignItems: "center" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            alignItems: "center",
                            padding: "0 10px",
                            boxShadow: "0px 3px 5px #999ba845",

                            border: "1px solid",
                            borderRadius: 10,
                            borderColor: fiber.active ? "#0500a3" : "#c9c9c9",
                          }}
                        >
                          <div
                            style={{ flex: 1, cursor: "pointer" }}
                            onClick={() => {
                              const newCoverageRoutes = coverageRoutes.map(
                                (s, i) => {
                                  return {
                                    ...s,
                                    active: index === i ? true : false,
                                  };
                                }
                              );
                              dispatch(setCoverageFibers(newCoverageRoutes));

                              const splitFiber = fiber.LATLON?.split("@");

                              const newCoordinate = splitFiber.map((s) => {
                                const splitLatLng = s.split(",");
                                return {
                                  lat: +splitLatLng[1],
                                  lng: +splitLatLng[0],
                                };
                              });

                              dispatch(
                                setCenterMap({
                                  lat: +newCoordinate[0]?.lat,
                                  lng: +newCoordinate[0]?.lng,
                                })
                              );

                              // setSampleFiber([{ coordinate: newCoordinate }]);
                            }}
                          >
                            <div
                              style={{
                                color: "#0500a3",
                                whiteSpace: "nowrap",
                                width: 300,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: 18,
                              }}
                            >
                              {/* {fiber.name} */}
                              {`Route ID : ${fiber.routeId}, Type : ${fiber.layerName}`}
                            </div>
                            <div style={{ color: "#c9c9c9" }}>{fiber.name}</div>
                          </div>
                          {fiber.active && (
                            <div style={{ width: 60 }}>
                              <Button
                                className="btn-search-repair-point"
                                shape="round"
                                onClick={() => {
                                  const splitFiber = fiber.LATLON?.split("@");

                                  const newCoordinate = splitFiber.map((s) => {
                                    const splitLatLng = s.split(",");
                                    return {
                                      latitude: +splitLatLng[1],
                                      longitude: +splitLatLng[0],
                                      lat: +splitLatLng[1],
                                      lng: +splitLatLng[0],
                                    };
                                  });
                                  dispatch(
                                    setRepairDetail({
                                      ...repairDetail,
                                      polylines: [
                                        ...repairDetail.polylines,
                                        {
                                          coordinate: newCoordinate,
                                          stationCode: 3,
                                          fiberRouteId: fiber.routeId,
                                        },
                                      ],
                                    })
                                  );
                                  dispatch(setCoverageFibers([]));
                                  // setSampleFiber([]);
                                }}
                              >
                                Select
                              </Button>
                            </div>
                          )}
                          {/* <div style={{ backgroundColor: "red", width: 60 }}>
                          a
                        </div> */}
                        </div>

                        {/* {fiber.active && (
                        <div style={{ backgroundColor: "red", width: 60 }}>
                          a
                        </div>
                      )} */}
                      </div>

                      // <List.Item
                      //   actions={[
                      //     <Button
                      //       className="btn-search-repair-point"
                      //       shape="round"
                      //       onClick={() => {
                      //         // handleSetMarkerLatLng(index, {
                      //         //   pkId: site.pkId,
                      //         //   latitude: +site.lat,
                      //         //   longitude: +site.lon,
                      //         //   siteCode: site.siteCode,
                      //         //   siteName: site.siteName,
                      //         // });
                      //         // handleSetCenterMap({
                      //         //   lat: +site.lat,
                      //         //   lng: +site.lon,
                      //         // });
                      //         // setVisibleModal(false);
                      //         // if (item.stationCode === 1) {
                      //         //   handleGetCoverageFibers(site.siteCode);
                      //         // }
                      //       }}
                      //     >
                      //       Select
                      //     </Button>,
                      //   ]}
                      // >
                      //   <List.Item.Meta
                      //     title={fiber.name}
                      //     description={`Route ID : ${fiber.routeId}, Layer Type : ${fiber.layerName}`}
                      //   />
                      // </List.Item>
                    )}
                  />
                </div>
              </div>
            </Draggable>
          )}
          <Modal
            title="เพิ่มรายละเอียดการซ่อมบำรุง"
            centered
            visible={modalAddVisible}
            footer={null}
            width={420}
            // onOk={() => this.setModal1Visible(false)}
            onCancel={() => setModalAddVisible(false)}
          >
            <div className="row">
              <div className="col-12">
                {new Array(...repairType.values()).map((item, index) => (
                  // <p key={index}>{item[1].name}</p>
                  <RepairTypeButton
                    key={index}
                    add
                    className="mb-3"
                    style={{ height: 40 }}
                    active={true}
                    left={<img src={item.icon} alt="" />}
                    title={item.name}
                    onClick={() => {
                      setPositionAdd({ ...positionAdd, visible: true });
                      setModalAddVisible(false);
                      let markers = [];
                      let polylines = [];
                      let name = "";
                      let repairTypeName = "";
                      switch (item.id) {
                        case 1:
                          name = initRepairType.straddle.name;
                          repairTypeName =
                            initRepairType.straddle.repairTypeName;
                          markers = initRepairType.straddle.markers;
                          polylines = initRepairType.straddle.polylines;
                          break;
                        case 2:
                          name = initRepairType.loop.name;
                          repairTypeName = initRepairType.loop.repairTypeName;
                          markers = initRepairType.loop.markers;
                          polylines = initRepairType.loop.polylines;
                          break;
                        case 3:
                          name = initRepairType.core.name;
                          repairTypeName = initRepairType.core.repairTypeName;
                          markers = initRepairType.core.markers;
                          polylines = initRepairType.core.polylines;
                          break;
                        case 4:
                          name = initRepairType.indoor.name;
                          repairTypeName = initRepairType.indoor.repairTypeName;
                          markers = initRepairType.indoor.markers;
                          polylines = initRepairType.indoor.polylines;
                          break;

                        default:
                          break;
                      }
                      dispatch(
                        setRepairDetail({
                          ...repairDetail,
                          repairTypeID: item.id,
                          name: name,
                          repairTypeName: repairTypeName,
                          markers: markers,
                          polylines: polylines,
                        })
                      );
                      setMapOptions({
                        ...mapOptions,
                        draggableCursor: "crosshair",
                      });
                    }}
                  />
                ))}
              </div>
            </div>
          </Modal>
          <GoogleMapCustomized
            zoom={16}
            center={mapCenter}
            // cursor={"crosshair"}
            mapOptions={mapOptions}
            markers={markers}
            // markers={markers.filter((f) =>
            //   typeActive.includes(f.repairPointID)
            // )}
            addMarkers={repairDetail.markers}
            polylines={polylines}
            // polylines={polylines.filter((f) =>
            //   typeActive.includes(f.repairPointID)
            // )}
            addPolylines={repairDetail.polylines}
            isMarkerShown
            googleMapURL={
              "https://maps.googleapis.com/maps/api/js?key=" + googleKey
            }
            loadingElement={<div style={{ height: `100%`, width: `100%` }} />}
            containerElement={<div style={{ height: 500, width: `100%` }} />}
            mapElement={<div style={{ height: `100%`, width: `100%` }} />}
            onClick={(e) => {
              const { latLng } = e;
              handleGetLatLng(latLng.lat(), latLng.lng());
            }}
            onMarkerClick={(item, index) => {
              setPositionDetail({
                ...positionDetail,
                visible: true,
                layerDetail: item,
              });
              setMarkers(
                markers.map((m, i) => {
                  if (i === index) {
                    return { ...m, animation: 1 };
                  }
                  return { ...m, animation: 0 };
                })
              );
            }}
            sampleFiber={coverageRoutes}
          />
        </>
      )}
    </>
  );
};

export default MapRepairPoint;
